/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkout_Courier_NoteInputs */

const en_checkout_courier_note = /** @type {(inputs: Checkout_Courier_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`* Couriers calculate delivery speed and priority using this matrix tracking.`)
};

const es_checkout_courier_note = /** @type {(inputs: Checkout_Courier_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`* Los mensajeros calculan la velocidad de entrega utilizando este seguimiento matricial.`)
};

const fr_checkout_courier_note = /** @type {(inputs: Checkout_Courier_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`* Les livreurs calculent la vitesse et la priorité de livraison en utilisant ce suivi matriciel.`)
};

const de_checkout_courier_note = /** @type {(inputs: Checkout_Courier_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`* Kuriere berechnen Liefergeschwindigkeit und Priorität anhand dieses Tracking-Systems.`)
};

const id_checkout_courier_note = /** @type {(inputs: Checkout_Courier_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`* Kurir menghitung kecepatan dan prioritas pengiriman menggunakan pelacakan matriks ini.`)
};

/** @type {(inputs: Checkout_Courier_NoteInputs) => LocalizedString} */
const ja_checkout_courier_note = en_checkout_courier_note;

/** @type {(inputs: Checkout_Courier_NoteInputs) => LocalizedString} */
const zh_checkout_courier_note = en_checkout_courier_note;

/** @type {(inputs: Checkout_Courier_NoteInputs) => LocalizedString} */
const ar_checkout_courier_note = en_checkout_courier_note;

/** @type {(inputs: Checkout_Courier_NoteInputs) => LocalizedString} */
const it_checkout_courier_note = en_checkout_courier_note;

/** @type {(inputs: Checkout_Courier_NoteInputs) => LocalizedString} */
const ru_checkout_courier_note = en_checkout_courier_note;

/** @type {(inputs: Checkout_Courier_NoteInputs) => LocalizedString} */
const pt_checkout_courier_note = en_checkout_courier_note;

/** @type {(inputs: Checkout_Courier_NoteInputs) => LocalizedString} */
const ko_checkout_courier_note = en_checkout_courier_note;

/**
* | output |
* | --- |
* | "* Couriers calculate delivery speed and priority using this matrix tracking." |
*
* @param {Checkout_Courier_NoteInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const checkout_courier_note = /** @type {((inputs?: Checkout_Courier_NoteInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkout_Courier_NoteInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_checkout_courier_note(inputs)
	if (locale === "es") return es_checkout_courier_note(inputs)
	if (locale === "fr") return fr_checkout_courier_note(inputs)
	if (locale === "de") return de_checkout_courier_note(inputs)
	if (locale === "ja") return ja_checkout_courier_note(inputs)
	if (locale === "zh") return zh_checkout_courier_note(inputs)
	if (locale === "ar") return ar_checkout_courier_note(inputs)
	if (locale === "id") return id_checkout_courier_note(inputs)
	if (locale === "it") return it_checkout_courier_note(inputs)
	if (locale === "ru") return ru_checkout_courier_note(inputs)
	if (locale === "pt") return pt_checkout_courier_note(inputs)
	return ko_checkout_courier_note(inputs)
});